var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-radio text text--caption-bold",class:[{ 'is-active': _vm.isActive }, _vm.customClass],attrs:{"disabled":_vm.isActive},on:{"click":_vm.onClickHandler}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }